import { RootState } from '@services/store/type'

export const getRequestListFetching = (state: RootState) =>
	state.requestList.fetching
export const getRequestListFetched = (state: RootState) =>
	state.requestList.fetched
export const getRequestList = (state: RootState) => state.requestList
